import styles from './index.module.sass';
import arrowSvg from '@/modules/mixing/images/arrow-down.svg';
import sleeveWarehouseIcon from '@/modules/mixing/images/sleeveWarehouse.svg';
import defaultWarehouseIcon from '@/modules/mixing/images/defaultWarehouse.svg';
import { useStore } from 'effector-react';
import {
  $calculatorWarehouseById,
  $calculatorWarehouseByIdLoadingIndicator,
  $warehouseData,
  fetchWarehouseData,
  fetchWarehouseSleevesById,
  resetLoadingIndicator,
} from '@/widgets/recipe/model';
import { useEffect, useRef } from 'react';
import { CultureItem } from '../culture-item';
import { IWarehouseWithBagsApi } from '@/modules/warehouses/ts';
import { IBagApi } from '@/modules/bags/ts';
import { Spin, notification } from 'antd';
import { ICalculatorBag } from '@/modules/mixing/ts/rustmix-buyer.types';
import { exportGrainSpecsToCalculator } from '@/modules/mixing/helpers';
import { mixBag, setBag } from '@/features/edit-bag/model';
import { toggleLeftWh, toggleRightWh } from '@/widgets/storage-viewer/model';
// import InfiniteScroll from 'react-infinite-scroll-component';

export const WarehouseItem = ({
  title,
  type,
  count,
  id,
  idx,
  description,
  activeWh,
  setActiveWh,
  setBagFoo,
  hideModalFoo,
  selectedBags,
  setSelectedBags,
  componentNumber,
  pagination,
  setPagination,
  setBagDefStateFoo,
}: IArgs) => {
  const warehouseData: IWarehouseWithBagsApi[] | any = useStore(
    $calculatorWarehouseById,
  );
  const loadingData = useStore($calculatorWarehouseByIdLoadingIndicator);

  // console.log(loadingData);

  useEffect(() => {
    setPagination({
      ...pagination,
      pages_count: Math.ceil(warehouseData?.filled_bags_agriculture_id / 10),
    });
  }, [warehouseData]);

  const handleSelectBag = (idx: number) => {
    if (Array.isArray(warehouseData.bags[idx - 1]?.values)) {
      const dataForImport = exportGrainSpecsToCalculator(
        warehouseData.bags[idx - 1]?.values,
        warehouseData.bags[idx - 1]?.weight,
      );
      setBagFoo && setBagFoo(dataForImport);
      setBagDefStateFoo(dataForImport);
      return; // hideModalFoo();
    }
    notification.warning({
      message: 'Ошибка при работе с данными. Попробуйте, пожалуйста, позже',
    });
  };

  const ref = useRef(null);

  const fetchMore = () => {
    setPagination((state: any) => {
      fetchWarehouseSleevesById({ id, limit: pagination.limit, page: state.page + 1 });

      return { ...pagination, page: state.page + 1 };
    });
    // fetchWarehouseSleevesById({ id, limit: pagination.limit, page: pagination.page })
  };

  const handleScroll = (e: any) => {
    // const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    // if (bottom && pagination.page < Number(pagination.pages_count)) {
    //   resetLoadingIndicator();
    //   fetchMore();
    // }
  };

  console.log(warehouseData?.bags);

  return (
    <div className={styles.root}>
      <div
        className={styles.visiblePart}
        onClick={() => {
          setPagination({ ...pagination, page: 1 });
          if (count <= 0) {
            return notification.warning({
              message: 'Склад не содержит наполненных рукавов/секций',
            });
          }
          setActiveWh(activeWh === id ? -1 : id);
        }}
      >
        <div className={styles.leftSide}>
          <img
            src={arrowSvg}
            alt="arrow"
            style={{ transform: `rotate(${activeWh !== id ? '180deg' : '0deg'})` }}
          />
          <span>{title}</span>
        </div>
        <div className={styles.rightSide}>
          <span className={styles.count}>{count} шт</span>
          <WarehouseBadge type={type} />
          <span className={styles.description}>{description}</span>
        </div>
      </div>
      <div
        className={styles.advancedPart}
        style={{ display: id === activeWh ? 'block' : 'none' }}
        ref={ref}
        onScroll={handleScroll}
      >
        {/* <InfiniteScroll
          loader={'loading...'}
          dataLength={warehouseData?.filled_bags || 10}
          next={fetchMore}
          hasMore={true}
        > */}
        {warehouseData ? (
          Array.isArray(warehouseData?.bags) &&
          warehouseData?.bags?.map((item: IBagApi, i: number) => {
            if (item.agriculture_id) {
              const wheat_class = Number(
                item.values.find((item) => item.name === 'Класс')?.value,
              );
              return (
                <CultureItem
                  key={i}
                  id={item.id}
                  idx={i + 1}
                  date={String(item.filling_date)}
                  title={`Пшеница, ${
                    !isNaN(wheat_class) && wheat_class !== 0
                      ? `${wheat_class}-й класс`
                      : 'Фураж'
                  }`}
                  grainType={String(item.sort)}
                  weight={item.weight}
                  isSelected={{
                    state: selectedBags.includes(item.id),
                    idx: selectedBags.indexOf(item.id) + 1,
                  }}
                  onClick={(idx) => {
                    handleSelectBag(idx);
                    setBag({ id: item.id, idx: componentNumber - 1 });
                    if (componentNumber === 1) {
                      toggleLeftWh({ id: warehouseData.id, name: warehouseData.name });
                      // setSelectedBags([item.id, selectedBags[1]]);
                      //localStorage.setItem('L_BAG', item.id);
                    } else {
                      toggleRightWh({ id: warehouseData.id, name: warehouseData.name });
                      // setSelectedBags([selectedBags[0], item.id]);
                      //localStorage.setItem('R_BAG', item.id);
                    }
                  }}
                  temp={Number(
                    item.values.find((item) => item.name === 'Температура')?.value,
                  )}
                  humidity={Number(
                    item.values.find((item) => item.name === 'Влажность культуры')
                      ?.value,
                  )}
                  fallingNumber={Number(
                    item.values.find((item) => item.name === 'Число падения')?.value,
                  )}
                  type={type}
                />
              );
            }
          })
        ) : (
          <div className={styles.loaderWrap}>
            <Spin className={styles.loader} />
          </div>
        )}
        {warehouseData && loadingData.loading && (
          <div className={styles.loaderWrap}>
            <Spin className={styles.loader} />
          </div>
        )}
        {/* </InfiniteScroll> */}
      </div>
    </div>
  );
};

function WarehouseBadge({ type }: { type: 1 | 2 }) {
  return (
    <div className={styles.warehouseBadge}>
      <img src={type === 2 ? sleeveWarehouseIcon : defaultWarehouseIcon} />
      <span>{type === 2 ? 'рукава' : 'склад'}</span>
    </div>
  );
}

interface IArgs {
  title: string;
  type: 1 | 2;
  count: number;
  id: number;
  idx: number;
  description: string;
  activeWh: number;
  setActiveWh: (val: number) => void;
  setPagination: any; //(val: { page: number; limit: number }) => void;
  setBagFoo?: (val: ICalculatorBag) => void;
  hideModalFoo: () => void;
  selectedBags: string[];
  setSelectedBags: (val: string[]) => void;
  componentNumber: 1 | 2;
  pagination: { page: number; limit: number; pages_count: number | null };
  setBagDefStateFoo: (val: any) => void;
}
